// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

:root {
  --layer-number-color: #9a7518;
}

.neuroglancer-layer-panel {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  margin-left: -5px;
  margin-top: -1px;
  z-index: -0.1;
}

.neuroglancer-layer-item {
  position: relative;
  display: flex;
  align-items: center;
  color: white;
  cursor: pointer;
  border-width: 1px;
  border-style: solid;
  border-color: #ccc;
  font-family: sans-serif;
  font-size: 10pt;
  background-color: black;
  padding: 1px;
}

.neuroglancer-layer-item,
.neuroglancer-layer-add-button {
  margin: 1px;
  margin-left: 5px;
}

.neuroglancer-layer-item[data-selected="true"] {
  border-color: #8c8;
}

.neuroglancer-layer-item[data-selected="true"]:hover {
  border-color: #3c3;
}

.neuroglancer-layer-item:hover {
  border-color: #daa520;
}

.neuroglancer-layer-item[data-pick="true"] .neuroglancer-layer-item-label {
  background-color: #939;
}

.neuroglancer-layer-item-label {
  display: inline-block;
  position: relative;
  background-color: #222;
  padding-right: 3px;
}

.neuroglancer-layer-item-number {
  display: inline-block;
  background-color: var(--layer-number-color);
  font-weight: bold;
  padding-left: 1px;
  padding-right: 1px;
}

.neuroglancer-layer-panel[data-show-hover-values="true"]
  .neuroglancer-layer-item-value {
  display: inline-block;
  font-family: monospace;
  font-size: medium;
  max-width: 50ch;
  margin-left: 1ch;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipses;
  text-align: center;
}

.neuroglancer-layer-panel[data-show-hover-values="false"]
  .neuroglancer-layer-item-value {
  display: none;
}

.neuroglancer-layer-item[data-visible="false"] .neuroglancer-layer-item-label {
  text-decoration: line-through;
}

.neuroglancer-layer-item[data-visible="false"] {
  color: #bbb;
}

.neuroglancer-layer-panel-drop-zone {
  display: inline-block;
  flex: 1;
}

.neuroglancer-layer-item-visible-progress,
.neuroglancer-layer-item-prefetch-progress {
  position: absolute;
  left: 0px;
  height: 2px;
  background-color: #666;
}

.neuroglancer-layer-item-visible-progress {
  top: 0px;
}

.neuroglancer-layer-item-prefetch-progress {
  bottom: 0px;
}

.neuroglancer-layer-item-value-container {
  display: grid;
  grid-template-columns: min-content;
  align-items: center;
}

.neuroglancer-layer-item-value {
  grid-row: 1;
  grid-column: 1;
  visibility: visible;
}

.neuroglancer-layer-item-button-container {
  grid-row: 1;
  grid-column: 1;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  visibility: hidden;
  justify-self: right;
}

.neuroglancer-layer-panel:hover .neuroglancer-layer-item-value {
  visibility: hidden;
}

.neuroglancer-layer-panel:hover .neuroglancer-layer-item-button-container {
  visibility: visible;
}
`, "",{"version":3,"sources":["webpack://./node_modules/neuroglancer/lib/ui/layer_bar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,OAAO;AACT;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/**\n * @license\n * Copyright 2016 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n:root {\n  --layer-number-color: #9a7518;\n}\n\n.neuroglancer-layer-panel {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: stretch;\n  margin-left: -5px;\n  margin-top: -1px;\n  z-index: -0.1;\n}\n\n.neuroglancer-layer-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  color: white;\n  cursor: pointer;\n  border-width: 1px;\n  border-style: solid;\n  border-color: #ccc;\n  font-family: sans-serif;\n  font-size: 10pt;\n  background-color: black;\n  padding: 1px;\n}\n\n.neuroglancer-layer-item,\n.neuroglancer-layer-add-button {\n  margin: 1px;\n  margin-left: 5px;\n}\n\n.neuroglancer-layer-item[data-selected=\"true\"] {\n  border-color: #8c8;\n}\n\n.neuroglancer-layer-item[data-selected=\"true\"]:hover {\n  border-color: #3c3;\n}\n\n.neuroglancer-layer-item:hover {\n  border-color: #daa520;\n}\n\n.neuroglancer-layer-item[data-pick=\"true\"] .neuroglancer-layer-item-label {\n  background-color: #939;\n}\n\n.neuroglancer-layer-item-label {\n  display: inline-block;\n  position: relative;\n  background-color: #222;\n  padding-right: 3px;\n}\n\n.neuroglancer-layer-item-number {\n  display: inline-block;\n  background-color: var(--layer-number-color);\n  font-weight: bold;\n  padding-left: 1px;\n  padding-right: 1px;\n}\n\n.neuroglancer-layer-panel[data-show-hover-values=\"true\"]\n  .neuroglancer-layer-item-value {\n  display: inline-block;\n  font-family: monospace;\n  font-size: medium;\n  max-width: 50ch;\n  margin-left: 1ch;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipses;\n  text-align: center;\n}\n\n.neuroglancer-layer-panel[data-show-hover-values=\"false\"]\n  .neuroglancer-layer-item-value {\n  display: none;\n}\n\n.neuroglancer-layer-item[data-visible=\"false\"] .neuroglancer-layer-item-label {\n  text-decoration: line-through;\n}\n\n.neuroglancer-layer-item[data-visible=\"false\"] {\n  color: #bbb;\n}\n\n.neuroglancer-layer-panel-drop-zone {\n  display: inline-block;\n  flex: 1;\n}\n\n.neuroglancer-layer-item-visible-progress,\n.neuroglancer-layer-item-prefetch-progress {\n  position: absolute;\n  left: 0px;\n  height: 2px;\n  background-color: #666;\n}\n\n.neuroglancer-layer-item-visible-progress {\n  top: 0px;\n}\n\n.neuroglancer-layer-item-prefetch-progress {\n  bottom: 0px;\n}\n\n.neuroglancer-layer-item-value-container {\n  display: grid;\n  grid-template-columns: min-content;\n  align-items: center;\n}\n\n.neuroglancer-layer-item-value {\n  grid-row: 1;\n  grid-column: 1;\n  visibility: visible;\n}\n\n.neuroglancer-layer-item-button-container {\n  grid-row: 1;\n  grid-column: 1;\n  white-space: nowrap;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  visibility: hidden;\n  justify-self: right;\n}\n\n.neuroglancer-layer-panel:hover .neuroglancer-layer-item-value {\n  visibility: hidden;\n}\n\n.neuroglancer-layer-panel:hover .neuroglancer-layer-item-button-container {\n  visibility: visible;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
